/**
 * Extracted from `analytics/RecentActivityCard.tsx` so the Map tab's own
 * "Recent Activity in View" card (`RecentActivityInView.tsx`) renders
 * timestamps in the identical "Xm/Xh/Xd ago" convention rather than a
 * second, drifted format.
 */
export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime()
  const now = Date.now()
  const diffMinutes = Math.round((now - then) / 60000)
  if (diffMinutes < 1) return "just now"
  if (diffMinutes < 60) return `${diffMinutes}m ago`
  const diffHours = Math.round(diffMinutes / 60)
  if (diffHours < 24) return `${diffHours}h ago`
  const diffDays = Math.round(diffHours / 24)
  return `${diffDays}d ago`
}
